import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
//
import Header from './header';
import Nav from './nav';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const Main = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);
  const [isNavCollapsed, setIsNavCollapsed] = useState(() => localStorage.getItem('hb-nav-collapsed') === 'true');

  useEffect(() => {

  }, [open, isNavCollapsed]);

  const toggleDrawer = () => {
    setOpen(!open);
  };

  const toggleNavCollapse = () => {
    setIsNavCollapsed((prev) => {
      const nextValue = !prev;
      localStorage.setItem('hb-nav-collapsed', String(nextValue));
      return nextValue;
    });
  };

  return (
    <StyledRoot>
      <Header
        toggleDrawer={toggleDrawer}
        isNavCollapsed={isNavCollapsed}
        toggleNavCollapse={toggleNavCollapse}
      />

      <Nav openNav={open} onCloseNav={toggleDrawer} isCollapsed={isNavCollapsed} />

      <Main>
        <Outlet />
      </Main>
    </StyledRoot>
  );
}
